import { Component, OnInit } from '@angular/core';
import { JarwisService } from '../../Services/jarwis.service';
import { TokenService } from '../../Services/token.service';
import { Router } from '@angular/router';
import { AuthService } from '../../Services/auth.service';
import { DataApiService } from 'src/app/Services/data-api.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  public form ={
    email: null,
    password: null,
  }
  public error = null;

  constructor( 
    private Jarwis:JarwisService,
    private Token:TokenService,
    private router :Router,
    private Auth:AuthService,
    private dataApi: DataApiService
    
  ){}
  onSubmit(){
    this.Jarwis.login(this.form).subscribe(
      data =>this.handleResponse(data),
      error =>this.handleError(error)
    )   
  }
  handleResponse(data){    
    console.log(data);
    this.Token.handle(data.access_token,this.typeLocalStorage(data.tipo_usuario),this.convenioLocalStorage(data.convenio));
    this.Auth.changeStatus(true);  
    if(data.tipo_usuario==1){ //adminstrador
      this.router.navigate(['/profile/map-admin']);
    }else if(data.tipo_usuario==2 || data.tipo_usuario==3){ 
       this.router.navigate(['/profile/pedido']);
      //localStorage.setItem("page","region");
      //this.router.navigate(['/escoge-tu-region']);
    }else if(data.tipo_usuario==4){
      this.router.navigate(['/motorizado']);
    }
    
  }

  typeLocalStorage(data){
    if( data == 1){
      return "administrador";
    }else if( data ==  2 ){
      return "persona";
    }else if(data == 3){
      return "empresa";
    }else if(data == 4){
      return "motorizado";
    }    
  }
  convenioLocalStorage(data){
    if(data==0){
      return "desactivado";
    }else if(data==1){
      return "activado";
    } 
  }
  
  visibility(visibility,visibilityIcon){ 
    const mostrar_password = document.querySelector(visibility);
    const type = mostrar_password.getAttribute("type");
    const visibility_icon = <HTMLElement>document.querySelector(visibilityIcon);
    if(type == "password"){
      mostrar_password.setAttribute("type","text");
      visibility_icon.classList.add('visibility_icon_active');
    }else{
      mostrar_password.setAttribute("type","password");
      visibility_icon.classList.remove('visibility_icon_active');
    }
  }
  handleError(error){
    this.error = error.error.error;
  }

  consultarAltaDemanda(){
    this.dataApi.getPrices().subscribe(
      data=>this.handleResponseAltaDemanda(data)
    )
  }
  handleResponseAltaDemanda(data:any){   
    const {altaDemanda}  = data;
    const highDemandModule = altaDemanda;

    localStorage.setItem("highDemandModule",highDemandModule);
    
  }
  ngOnInit() { 
    this.consultarAltaDemanda(); 
  }
   
 
}
